module.exports = __webpack_public_path__ + "static/media/clubOccupancyPlaceholder.3ea26a28.png";